<h3 mat-dialog-title>{{ data.title }}</h3>
<div mat-dialog-content>
   {{ data.message}}

</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{data.cancelText}}</button>
    <button mat-button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="delete()">{{ data.okText }}</button>
</div>